//@flow
import React, { Component } from "react";

type Props = {
  productDetailsUrl: string
};

class ButtonEnquireNow extends Component<Props> {
  redirectToSecureUrl(productDetailsUrl: string) {
    window.location.href = productDetailsUrl;
  }

  render() {
    return (
      <button
        className="enquire-now"
        onClick={() => this.redirectToSecureUrl(this.props.productDetailsUrl)}
      >
        Enquire
      </button>
    );
  }
}

export default ButtonEnquireNow;
